var _style, _path, _rect, _path2, _path3, _circle, _rect2, _rect3, _rect4, _rect5, _rect6, _path4, _path5, _path6, _path7, _rect7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLupaAnalise01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#235087;}\n\t.st1{fill:#EF2648;}\n\t.st2{fill:#163768;}\n\t.st3{fill:#B20D24;}\n\t.st4{fill:#B7E5FF;}\n\t.st5{fill:#99C8E0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1526",
    className: "st0",
    d: "M28.7,25.3l4.9,4.9c0.4,0.4,0.7,1.1,0.7,1.7l0,0c0,1.3-1.1,2.4-2.4,2.4l0,0l0,0 c-0.6,0-1.2-0.3-1.7-0.7l-4.9-4.9L28.7,25.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_608",
    x: 23.2,
    y: 23.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.6109 25.6192)",
    className: "st1",
    width: 4.8,
    height: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1527",
    className: "st2",
    d: "M27.9,26.5c0.7,0,1.4,0.1,2.1,0.1l-1.3-1.3l-1.1,1.1C27.7,26.5,27.8,26.5,27.9,26.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1528",
    className: "st3",
    d: "M28.7,25.3l-2.8-2.8l-3.4,3.4l1.1,1.1c1.3-0.3,2.6-0.5,3.9-0.6L28.7,25.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_67",
    className: "st4",
    cx: 15.2,
    cy: 15.2,
    r: 11.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_609",
    x: 11.2,
    y: 13.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -8.0728 13.0964)",
    className: "st1",
    width: 1.1,
    height: 4.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_610",
    x: 14.8,
    y: 15.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.8527 17.3278)",
    className: "st1",
    width: 6.4,
    height: 1.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_611",
    x: 31,
    y: 3.9,
    className: "st1",
    width: 4,
    height: 1.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_612",
    x: 3.9,
    y: 12.9,
    className: "st1",
    width: 3.4,
    height: 1.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_613",
    x: 25.4,
    y: 6.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 3.189 21.0721)",
    className: "st1",
    width: 3.2,
    height: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1529",
    className: "st0",
    d: "M8.9,15.7c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3S10.2,15.7,8.9,15.7 L8.9,15.7z M8.9,12.3c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0C10.1,12.8,9.6,12.3,8.9,12.3 C8.9,12.3,8.9,12.3,8.9,12.3L8.9,12.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1530",
    className: "st0",
    d: "M14.6,21.4c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3S15.8,21.4,14.6,21.4 L14.6,21.4z M14.6,18c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0C15.7,18.5,15.2,18,14.6,18 L14.6,18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1531",
    className: "st0",
    d: "M29.3,6.7c-1.2,0-2.3-1-2.3-2.3c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3l0,0 C31.6,5.7,30.5,6.7,29.3,6.7z M29.3,3.3c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0 C30.4,3.8,29.9,3.3,29.3,3.3C29.3,3.3,29.3,3.3,29.3,3.3L29.3,3.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1532",
    className: "st5",
    d: "M19.5,4.7c4.8,4,5.5,11.1,1.6,15.9c-3.2,3.9-8.5,5.2-13.1,3.3c4.8,4,12,3.2,15.9-1.6 c4-4.8,3.2-12-1.6-15.9C21.5,5.7,20.5,5.1,19.5,4.7z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_614",
    x: 22,
    y: 9.5,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.2036 19.6686)",
    className: "st1",
    width: 3.2,
    height: 1.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1533",
    className: "st3",
    d: "M24.3,8.6l-1.3,1.3c0.1,0.4,0.3,0.8,0.3,1.3L25,9.5C24.8,9.2,24.6,8.9,24.3,8.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1534",
    className: "st0",
    d: "M15.2,1.6C7.7,1.6,1.6,7.7,1.6,15.2s6.1,13.6,13.6,13.6c7.5,0,13.6-6.1,13.6-13.6 S22.7,1.6,15.2,1.6L15.2,1.6z M15.2,26.5c-6.2,0-11.3-5.1-11.3-11.3c0-6.2,5.1-11.3,11.3-11.3c6.2,0,11.3,5.1,11.3,11.3c0,0,0,0,0,0 C26.5,21.4,21.4,26.5,15.2,26.5L15.2,26.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1535",
    className: "st0",
    d: "M21.4,14.6c-1.2,0-2.3-1-2.3-2.3c0-1.2,1-2.3,2.3-2.3c1.2,0,2.3,1,2.3,2.3l0,0 C23.6,13.6,22.6,14.6,21.4,14.6z M21.4,11.2c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0 C22.5,11.7,22,11.2,21.4,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLupaAnalise01);
export default __webpack_public_path__ + "static/media/ico-lupa-analise-01.20accbcd9c9f270937eef72482333ae6.svg";
export { ForwardRef as ReactComponent };